import { useEffect, useState, useContext } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import { NumericFormat } from "react-number-format";
import Select from "react-select";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import LogicContext from "../../Context/LogicContext";
import DelgroProgressBar from "../../generals/DelgroProgressBar";
import { accountService } from "../../services/accountService";

const customStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: "#f9fafb",
    borderColor: state.isFocused ? "#0000FF" : "#d1d5db",
    boxShadow: state.isFocused ? "0 0 0 1px #9ca3af" : "none",
    height: 42,
    borderRadius: 6,
    paddingLeft: 4,
    paddingRight: 4,
    fontSize: 14,
    width: "50%",
    transition: "all 0.2s ease-in-out",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 8px",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#9ca3af",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#111827",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    color: state.isFocused ? "#6b7280" : "#9ca3af",
    "&:hover": {
      color: "#6b7280",
    },
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: "#ffffff",
    borderRadius: 6,
    boxShadow: "0 4px 14px rgba(0, 0, 0, 0.05)",
    marginTop: 4,
    fontSize: 14,
    boxShadow: "0 0 0 1px #d1d5db",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#FFFFFF"
      : state.isFocused
      ? "#f3f4f6"
      : "#ffffff",
    color: "#111827",
    padding: "8px 12px",
    cursor: "pointer",
    borderColor: state.isFocused ? "#9ca3af" : "#d1d5db",
    "&:hover": {
      backgroundColor: "#f3f4f6",
    },
    border: "2px",
    transition: "background-color 0.2s ease",
  }),
};

const ChartOfAccountOpeningPage = () => {
  const [tableData, setTableData] = useState({ account_main_head: [], chart_of_accounts: [] });
  const [tableDataBackUp, setTableDataBackUp] = useState({ account_main_head: [], chart_of_accounts: [] });
  const [optionList, setOptionList] = useState([]);
  const [searchQuery, setSearchQuery] = useState(""); // State for search query
  const myPromiseModal = createModal(GeneralModal);
  const logicContext = useContext(LogicContext);

  useEffect(() => {
    document.title = "Chart account opening";
    loadDataFromServer();

  }, []);

  const loadDataFromServer = ()=> {
    accountService.getChartOfAccountOpeningBalance().then((res) => {
      const accData = res.data;
      if (accData) {
        setTableData(accData);
        setTableDataBackUp(accData);
        let newList = [
          { label: "All", value: "all" },
          ...accData.account_main_head.map((item) => ({
            ...item,
            label: item?.Account_Main_Name,
            value: item?.Account_Main_Id,
          })),
        ];
        setOptionList(newList);
      }
    });
  }

  // Handle search input change
  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);

    // Filter table data based on search query
    if (query.trim() === "") {
      setTableData(tableDataBackUp); // Reset to original data if search is empty
    } else {
      const filteredAccounts = tableDataBackUp.chart_of_accounts.filter((acc) =>
        acc.Account_Name.toLowerCase().includes(query.toLowerCase())
      );
      setTableData((prev) => ({
        ...prev,
        chart_of_accounts: filteredAccounts,
      }));
    }
  };

  const onAccountTypeSelect = (type) => {
    const selType = type?.Account_Main_Id;
    let filteredAccounts = tableDataBackUp.chart_of_accounts;

    if (selType !== "all") {
      filteredAccounts = filteredAccounts.filter((acc) => acc.Account_Main_Id === selType);
    }

    // Apply search filter if there's a search query
    if (searchQuery.trim() !== "") {
      filteredAccounts = filteredAccounts.filter((acc) =>
        acc.Account_Name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    setTableData((prev) => ({
      ...prev,
      chart_of_accounts: filteredAccounts,
    }));
  };

  const onDebitAmountChangeChange = (debVal, acc) => {
    let tempDataAccount = tableData.chart_of_accounts.map((account) => {
      if (acc.Account_Id === account?.Account_Id) {
        return { ...account, DrAmt: debVal };
      } else {
        return account;
      }
    });
    setTableData((prevData) => ({
      ...prevData,
      chart_of_accounts: tempDataAccount,
    }));
  };

  const onCreditAmountChangeChange = (debVal, acc) => {
    let tempDataAccount = tableData.chart_of_accounts.map((account) => {
      if (acc.Account_Id === account?.Account_Id) {
        return { ...account, CrAmt: debVal };
      } else {
        return account;
      }
    });
    setTableData((prevData) => ({
      ...prevData,
      chart_of_accounts: tempDataAccount,
    }));
  };

  const saveAllAccount = async () => {
    const response = await myPromiseModal({
      title: "Save All Account",
      body: "All modified accounts will be saved!",
      showInput: false,
      placeHolder: "",
    });

    if (response.decision === true) {
      let xml_string = "";
      let temp = "";
      tableData.chart_of_accounts.map((acc, i) => {
        temp += `<a><account_id>${acc.Account_Id}</account_id><dramt>${acc.DrAmt}</dramt><cramt>${acc.CrAmt}</cramt></a>`;
      });
      xml_string = `<root>${temp}</root>`;

      accountService
        .updateOpeningBalance({ xml_string: xml_string })
        .then((res) => {
          const cleanResponse = logicContext.httpResponseManager(
            res.data?.[0] || res.data?.result_status?.[0]
          );
          loadDataFromServer();
          logicContext.showToast(cleanResponse?.message_text, "success");
        })
        .catch((err) => {
          console.log("Error...", err);
        });
    }
  };

  return (
    <>
      {!tableData.chart_of_accounts?.length && <DelgroProgressBar />}
      <section className="mt-6 p-6 bg-gray-50 rounded-lg shadow-sm">
        {/* Section Header */}
        <h6 className="mb-6 text-xl font-bold text-gray-900 md:text-2xl">
          Chart of Account Opening Balance
        </h6>

        {/* Search Bar and Account Type Selector */}
        <div className="mb-6 flex flex-col gap-4 md:flex-row md:items-center">
          <TextField
            label="Search Accounts"
            variant="outlined"
            value={searchQuery}
            onChange={handleSearchChange}
            className="w-full md:w-1/2"
            size="small"
            InputProps={{
              style: { backgroundColor: "#f9fafb" },
            }}
          />
          <Select
            onChange={(e) => onAccountTypeSelect(e)}
            options={optionList}
            styles={customStyles}
            defaultValue={{ label: "All", value: "all" }}
            className="text-sm w-full md:w-1/2"
          />
        </div>

        {/* Table Container */}
        <div className="overflow-x-auto rounded-lg shadow">
          <TableContainer component={Paper} className="bg-white">
            <Table aria-label="chart of accounts table" className="min-w-full">
              <TableHead>
                <TableRow className="bg-gray-100">
                  {["Accounts", "Available Balance", "Debit", "Credit"].map((header, index) => (
                    <TableCell
                      key={index}
                      className="px-6 py-3 text-sm font-semibold text-gray-700 border-b border-gray-200"
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData.chart_of_accounts?.map((acc, i) => (
                  <TableRow
                    key={i}
                    className="hover:bg-gray-50 transition-colors duration-150"
                  >
                    {/* Account Name */}
                    <TableCell className="px-6 py-4 text-sm text-gray-800 border-b border-gray-200">
                      <div
                        title={acc.Account_Name}
                        className="max-w-xs truncate cursor-default"
                      >
                        {acc.Account_Name}
                      </div>
                    </TableCell>

                    {/* Available Balance */}
                    <TableCell className="px-6 py-4 text-sm text-gray-800 border-b border-gray-200 text-right">
                      <div
                        title={acc?.availableBalance}
                        className="max-w-[120px] truncate cursor-default ml-auto"
                      >
                        {acc?.availableBalance}
                      </div>
                    </TableCell>

                    {/* Debit */}
                    <TableCell className="px-6 py-4 text-sm text-gray-800 border-b border-gray-200 text-right">
                      <NumericFormat
                        value={acc?.DrAmt}
                        className="h-9 w-[100px] border border-gray-300 rounded-md px-2 text-right focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                        thousandSeparator=","
                        decimalSeparator="."
                        onValueChange={(values) => {
                          onDebitAmountChangeChange(values.value, acc);
                        }}
                      />
                    </TableCell>

                    {/* Credit */}
                    <TableCell className="px-6 py-4 text-sm text-gray-800 border-b border-gray-200 text-right">
                      <NumericFormat
                        value={acc?.CrAmt}
                        className="h-9 w-[100px] border border-gray-300 rounded-md px-2 text-right focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                        thousandSeparator=","
                        decimalSeparator="."
                        onValueChange={(values) => {
                          onCreditAmountChangeChange(values.value, acc);
                        }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>

            {/* Save All Button */}
            <div className="flex justify-end p-4">
              <button
                onClick={() => saveAllAccount()}
                className="bg-blue-600 text-white text-sm font-medium px-4 py-2 rounded-md hover:bg-blue-700 transition-colors flex items-center"
              >
                Save All
              </button>
            </div>
          </TableContainer>
        </div>
      </section>
    </>
  );
};

export default ChartOfAccountOpeningPage;